import { request } from '../request'

/**
 * 添加奖励通道=》确认并支付
 * @param data
 * @return {Promise}
 */
export function getAwardOrder(data) {
  return request.post('/award/wjpayaccountrecord/awardOrderNew', data)
}

/**
 * 充值按钮 二维码
 * @param data
 * @return {Promise}
 */
export function getCharge(data) {
  return request.post('/award/wjpayaccountrecord/wechatCharge', data)
}

/**
 * 去支付按钮
 * @param data
 * @return {Promise}
 */
export function goPayment(data) {
  return request({
    url: '/award/wjpayaccountrecord/awardOrder',
    method: 'post',
    data
  })
}

export function getJurisdiction(data) {
  return request({
    url: '/award/wjpayaccountrecord/awardOrderNew',
    method: 'post',
    data
  })
}

export function getClickGoPayment(data) {
  return Promise.all([goPayment(data), getJurisdiction(data)])
}

// 支付
export function pay(data) {
  return request.post('/award/wjpayaccountrecord/pay', data)
}

// 获取余额
export function getYuE() {
  return request.get('/award/wjpayaccountrecord/balance')
}

export function confirmPay(data) {
  return request({
    url: '/award/wjpayaccountrecord/pay',
    method: 'post',
    data
  })
}

export function changeNeedAuditFlag(data) {
  return request({
    url: '/award/wjaward/updateNeedAuditFlag',
    method: 'put',
    data
  })
}

export function refund(params) {
  return request({
    url: '/award/wjpayaccountrecord/cancel',
    method: 'get',
    params
  })
}

export function confirmRefund(data) {
  return request({
    url: '/award/wjpayaccountrecord/cancel?awardId=' + data.awardId,
    method: 'post'
  })
}

export function confirmCancel(id) {
  return request({
    url: `/award/wjaward/closeAward?awardId=${id}`
  })
}

//取消支付
export function confirmCancelPayment(awardId) {
  return request({
    url: `/award/wjaward/closePayment`,
    method: 'put',
    params: {
      awardId: awardId
    }
  })
}

export function getAwardInfo(id) {
  return request({
    url: `/award/wjaward/${id}`
  })
}
